<div class="flex flex-col h-full overflow-y-auto">
  <!-- Header with logo and company name -->
  <div class="mb-6">
    <div class="mb-1 flex gap-2 items-center">
      <img class="object-contain w-6 h-6" src="assets/images/app-logo.webp" alt="logo">
      <span class="font-bold cursor-default" translate="no">Mr. Kresz</span>
    </div>
  </div>

  <!-- Navigation menu -->
  <div #loggedInUserInfo class="mb-6">

    <div class="flex flex-row items-center gap-3">
      <img class="block w-10 h-10 rounded-full" [src]="'assets/images/defaultprofile.webp'">
      <div class="flex flex-col flex-1 min-w-0">
        <div class="font-bold text-sm text-ellipsis overflow-hidden whitespace-nowrap">{{ getLoggedInUserName() }}</div>
        <div class="text-gray-400 text-[0.85rem] text-ellipsis overflow-hidden whitespace-nowrap">{{ getLoggedInUserEmail() }}</div>
      </div>
    </div>
  </div>


  <div class="flex-1">
    <nav class="space-y-6">
      <!-- Iterate through each menu group -->
      @for (group of menuGroups; track group.label) {
      <div class="space-y-2">
        <!-- Group label -->
        <div class="cursor-default text-xs font-medium text-gray-400 uppercase">
          {{ group.label }}
        </div>

        <!-- Menu items -->
        <div class="space-y-1">
          @for (item of group.menuItems; track item.name) {
          @if (item.type === 'single') {
          <!-- Single menu item with icon -->
          <app-single-menu-item [item]="{ name: item.name, icon: item.icon, url: item.url ?? '' }" (click)="appLayoutService.sidebarNavigateTo(item.url ?? '')" />
          } @else {
          <!-- Collapsable menu item with submenu -->
          <div>
            <div (click)="toggleExpand(item)"
              class="flex w-full items-center justify-between rounded-lg py-2 px-3 text-sm font-medium text-gray-700 md:hover:bg-slate-500/5 md:hover:text-gray-900 transition-colors cursor-pointer">
              <div class="flex items-center gap-2">
                <ng-icon [size]="'17px'" [name]="item.icon" class="h-5 w-5 icon"></ng-icon>
                <span>{{ item.name }}</span>
              </div>
              <div class="flex items-center">
                <ng-icon name="lucideChevronDown" class="h-4 w-4 ml-2 arrow-icon" [class.rotate-icon]="false"></ng-icon>
              </div>
            </div>

            <!-- Submenu items with animation and vertical line -->
            <div class="relative overflow-hidden">
              <!-- Vertical line -->
              <div class="absolute left-[18px] top-0 bottom-0 w-px bg-gray-200/80"></div>

              <div #submenuContent class="pl-9 space-y-1 submenu" [class.expanded]="item.expanded"
                [class.collapsed]="!item.expanded" [style.maxHeight.px]="item.expanded ? item.submenuHeight : 0"
                [attr.aria-expanded]="item.expanded">
                @for (subItem of item.subMenuItems; track subItem.name) {
                <a (click)="appLayoutService.sidebarNavigateTo(subItem.url)" [routerLink]="subItem.url" [routerLinkActiveOptions]="{ exact: true }" routerLinkActive="active-link"
                  class="flex items-center justify-between rounded-lg py-2 px-3 text-sm font-medium text-gray-700 md:hover:bg-slate-500/5 md:hover:text-gray-900 transition-colors cursor-pointer w-full">
                  <span>{{ subItem.name }}</span>
                </a>
                }
              </div>
            </div>
          </div>
          }
          }
        </div>
      </div>
      }
    </nav>
  </div>

  <div>
    <app-single-menu-item (click)="logout()" [item]="{ name: 'Kijelentkezés', icon: 'lucideLogOut', }"></app-single-menu-item>

    <div class="divider h-px bg-gray-200/80 my-6">

    </div>

    <span class="text-xs mr-1 text-gray-400">📞 </span>
    <a class="underline cursor-pointer text-xs text-gradient font-bold" matTooltip="Segíthetünk?" href="tel:+3663884000">+36 63 884 000 </a>
    <a class="block mt-1 text-xs text-gray-400 cursor-default">Magyar Digitális Oktatás Kft</a>
  </div>
</div>
